import { getEnvironmentVariables } from '@repo/shared-config/app/helper/environment-variables';
import { loadScript } from './load-script';

const ENV = getEnvironmentVariables();

export const authSdkLoader = {
  async loadGoogleSdk(): Promise<void> {
    if (!ENV.googleAuth?.sdkUrl) {
      throw new Error('Google Auth SDK URL is not configured');
    }
    await loadScript(ENV.googleAuth.sdkUrl);
  },

  async loadAppleSdk(): Promise<void> {
    if (!ENV.appleAuth?.sdkUrl) {
      throw new Error('Apple Auth SDK URL is not configured');
    }
    await loadScript(ENV.appleAuth.sdkUrl);
  },
};
